(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
* ログ送信
* @param s 基本的に進路内にグローバルに存在する『s』をいれる
* @param target イベント観測対象。event.targetの取得が困難な場合は、documentで代用可。
* @param customLink カスタムリンク
*/
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.initScrollLog = initScrollLog;
function sendLog(s, target, customLink) {
  if (!s) return;
  s.tl(target, 'o', customLink);
}

/**
* スクロールログinit
* @param s 基本的に進路内にグローバルに存在する『s』をいれる
* @param scrollLogTargetList イベント観測対象
* @param dataNameInView - 表示領域inで飛ばしたいログ設定用のデータ属性名（data-xxxxの部分のキャメルケースのみ）
* @returns 処理後のターゲットリスト
*/

function initScrollLog(s, scrollLogTargetList, dataNameInView) {

  // オプション設定
  var options = {
    root: null,
    rootMargin: '0px',
    threshold: 1
  };
  // 要素が画面に入ったときの処理
  var inViewCallback = function inViewCallback(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var customLink = entry.target.dataset[dataNameInView];
      sendLog(s, entry.target, customLink);
      // 一度inViewログを飛ばしたら、監視をやめる
      observer.unobserve(entry.target);
    });
  };

  // IntersectionObserverを呼ぶ
  var observer = new IntersectionObserver(inViewCallback, options);
  scrollLogTargetList.forEach(function (target) {
    observer.observe(target);
  });
}

},{}],2:[function(require,module,exports){
/**
 * 【KARTE_LPO】#x_オプトLP
 * 読み込み画面：https://shingakunet.com/rnet/s/campaign/shiryou/202407/
 * js、cssは他Tが作成したものをそのまま使用する。
 * FE側では上記ページに対してログ追加の要件があったため、ログ用に本ファイルを新規作成。
 * 他Tが作成したjs処理の都合上、既存モジュール(/js/assets/component/_sendClickLog.js)内の処理を改修する必要があったため下記の通りとした。
 */
'use strict';

var _jsAssetsComponent_sendScrollLog = require('../../../js/assets/component/_sendScrollLog');

// ログ送信処理
var scrollLogElement = document.querySelectorAll('.js-inviewLog');
var clickLogElement = document.querySelectorAll('.js-clickLog');

(0, _jsAssetsComponent_sendScrollLog.initScrollLog)(window.s, scrollLogElement, 'inviewLog');
initClickLog(clickLogElement, 'clickLog');

function sendLog(target, messageID) {
  if (!s) return;
  s.tl(target, 'o', messageID);
}

function initClickLog(clickLogElementList, dataName) {
  var clickLogTriggerElements = Array.prototype.slice.call(clickLogElementList, 0);
  clickLogTriggerElements.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      var activeChild = trigger.querySelector('.is-active');
      var accordionChild = trigger.classList.contains('js-accordion');
      if (activeChild || !accordionChild) {
        var clickedElement = event.currentTarget;
        var customLink = clickedElement.dataset[dataName];
        sendLog(clickedElement, customLink);
      }
    });
  });
}

},{"../../../js/assets/component/_sendScrollLog":1}]},{},[2]);
